import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, TextField, Button, Paper } from "@mui/material";
import Logo from "../assets/logo.png"; // importera din logga

export default function LandingPage() {
  const navigate = useNavigate();
  const [documentId, setDocumentId] = useState("");
  const [signerToken, setSignerToken] = useState("");

  const handleSearch = () => {
    if (!documentId || !signerToken) return;
    navigate(`/sign-document?documentId=${documentId}&signer=${signerToken}`);
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{
        background: "linear-gradient(to bottom right, #7AB2D3, #b3e5fc)",
        p: 3,
      }}
    >
      <Box textAlign="center" maxWidth={500} width="100%">
        {/* Logo */}
        <Box mb={4}>
          <img src={Logo} alt="OceanLogix" style={{ width: 200 }} />
        </Box>

        {/* Header text */}
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Welcome to eSign by OceanLogix
        </Typography>
        <Typography variant="body1" color="textSecondary" mb={3}>
          To sign a document, you need both the Document ID and your Signature
          Token.
        </Typography>

        {/* Form container */}
        <Paper elevation={3} sx={{ p: 3 }}>
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              label="Document ID"
              value={documentId}
              onChange={(e) => setDocumentId(e.target.value)}
              fullWidth
            />
            <TextField
              label="Signature Token"
              value={signerToken}
              onChange={(e) => setSignerToken(e.target.value)}
              fullWidth
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleSearch}
              disabled={!documentId || !signerToken}
            >
              Search Document
            </Button>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}
